exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".return-list[data-v-58443f54]{padding-bottom:10px;display:block;border-bottom:1px solid #ccc;cursor:pointer}.tab-headers button[data-v-58443f54]{width:50%;border:1px solid #ddd;background:#ccc}.active[data-v-58443f54]{background:#eee!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58443f54","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/CompanyConversation.vue
// module id = FNSK
// module chunks = 0